import { useParams, Navigate, Link } from 'react-router-dom';
import { SEOHead } from '../components/SEOHead';
import { CallbackForm } from '../components/CallbackForm';
import { Footer } from '../components/Footer';
import { AuthorByline } from '../components/AuthorComponents';
import { translations } from '../translations';
import { useLayoverConfig } from '../data/layoverConfig';
import { getLayoverPage } from '../data/layoverContent';
import { hubPath, hubUrl, childUrl, LayoverGuarantee, LayoverSiblingNav, LayoverPriceBlock, LayoverCommonBlocks, buildLayoverSchema } from '../components/LayoverShared';
import './seo-pages.css';
import './PrivateIstanbulTours.css';

const L = {
  en: { home: 'Home', hub: 'Istanbul Layover Tours', bc: 'Breadcrumb', itinerary: 'Itinerary at a glance', price: 'Price', faq: 'Frequently asked questions', flight: 'Tell us your flight times', publishDate: 'October 2026' },
  ar: { home: 'الرئيسية', hub: 'جولات الترانزيت في إسطنبول', bc: 'مسار التنقل', itinerary: 'البرنامج في لمحة', price: 'السعر', faq: 'الأسئلة الشائعة', flight: 'أخبرنا بمواعيد رحلاتك', publishDate: 'October 2026' },
};

export default function LayoverChildPage({ language }) {
  const { slug } = useParams();
  const lang = language === 'ar' ? 'ar' : 'en';
  const cfg = useLayoverConfig();
  const t = translations[language];
  const l = L[lang];
  const page = getLayoverPage(slug, cfg, lang);
  if (!page) return <Navigate to={hubPath(lang)} replace />;
  const url = childUrl(slug, lang);
  const homePath = lang === 'ar' ? '/ar' : '/';
  const schema = buildLayoverSchema({ cfg, url, lang, name: page.h1, description: page.metaDescription, itinerary: page.itinerary, faqs: page.faqs, airport: page.airport, durationKey: page.durationKey,
    breadcrumbs: [{ name: l.home, url: `https://viaturkey.net${homePath}` }, { name: l.hub, url: hubUrl(lang) }, { name: page.h1, url }] });

  return (
    <div className="pit-page" data-testid={`layover-child-${slug}`}>
      <SEOHead title={`${page.title} | Viaturkey`} description={page.metaDescription} canonical={url} schema={schema} />
      <article className="pit-container" style={{ paddingTop: '110px' }}>
        <div className="pit-body">
          <nav className="lo-breadcrumb" aria-label={l.bc}><Link to={homePath}>{l.home}</Link> › <Link to={hubPath(lang)}>{l.hub}</Link> › <span>{page.h1}</span></nav>
          <h1>{page.h1}</h1>
          <AuthorByline publishDate={l.publishDate} />
          <LayoverGuarantee cfg={cfg} lang={lang} />
          <p className="lo-intro" data-testid="layover-child-intro">{page.intro}</p>
          {page.sections.map((sct, i) => (<div key={i}><h2>{sct.h}</h2><p>{sct.p}</p></div>))}
          <h2>{l.itinerary}</h2>
          <ol className="lo-itinerary" data-testid="layover-child-itinerary">{page.itinerary.map((it, i) => <li key={i}>{it}</li>)}</ol>
          <h2>{l.price}</h2>
          <LayoverPriceBlock cfg={cfg} durationKey={page.durationKey} lang={lang} />
          <LayoverCommonBlocks cfg={cfg} meet={page.meet} dontBook={page.dontBook} airport={page.airport} lang={lang} />
          <h2>{l.faq}</h2>
          {page.faqs.map((f, i) => (<details key={i} className="gp-faq-item" data-testid={`layover-child-faq-${i}`}><summary>{f.q}</summary><p>{f.a}</p></details>))}
          <LayoverSiblingNav current={slug} lang={lang} />
          <h2>{l.flight}</h2>
          <CallbackForm language={language} sourcePage={`layover-${slug}`} />
        </div>
      </article>
      <Footer t={t} />
    </div>
  );
}
